module.exports = __webpack_public_path__ + "static/media/WhatWeDo_Consultancy.6a9b44a9.jpg";